import type {
  SwapConfirmRequest,
  SwapConfirmResult,
  SwapPair,
  SwapRate,
} from '@/lib/api/swap/models';
import type {
  SwapConfirmRequestDto,
  SwapConfirmResponseDto,
  SwapPairDto,
  SwapRateWsMessage,
} from '@/lib/api/swap/types';

// --- Swap Pair: DTO → Domain ---

export function mapSwapPair(dto: SwapPairDto): SwapPair {
  return {
    id: dto.i,
    baseCurrency: dto.bc,
    quoteCurrency: dto.qc,
    isActive: dto.a,
    markupPercent: dto.mp,
    feePercent: dto.fp,
    deltaChangePercent: dto.dp,
    delayMs: dto.dl,
    minAmount: dto.mn,
    maxDailyAmount: dto.mx,
  };
}

// --- Confirm: Domain → DTO ---

export function toSwapConfirmDto(body: SwapConfirmRequest): SwapConfirmRequestDto {
  return {
    bc: body.baseCurrency,
    qc: body.quoteCurrency,
    am: body.amount,
    cr: body.clientRate,
    ts: body.timestamp,
  };
}

// --- Confirm: DTO → Domain ---

export function mapSwapConfirmResult(dto: SwapConfirmResponseDto): SwapConfirmResult {
  return {
    orderId: dto.oi,
    status: dto.s,
    baseCurrency: dto.bc,
    quoteCurrency: dto.qc,
    sourceAmount: dto.sa,
    targetAmount: dto.ta,
    rate: dto.r,
    feeAmount: dto.fa,
    feeCurrency: dto.fc,
  };
}

// --- WebSocket Rate: DTO → Domain ---

export function mapSwapRate(msg: SwapRateWsMessage): SwapRate {
  return {
    baseCoinId: msg.d.bc,
    quoteCoinId: msg.d.qc,
    rate: msg.d.r,
    timestamp: Math.floor(Date.now() / 1000),
  };
}
